// extracted by css-extract-rspack-plugin
export default {"downloadToolbar":"g4VviQnmgqgR42xm","tableWrapper":"SqzTPfnDMvMiyEIx"};